import {Stack} from '@mui/material';
import React from 'react';

import {translations} from 'presentation/translations-new';

import {UnitCardActions} from './components/UnitCardActions';
import {UnitCardAddress} from './components/UnitCardAddress';
import {UnitCardHeader} from './components/UnitCardHeader';
import {useUnitCard} from './hooks/useUnitCard';
import {StyledCard} from './styles';
import {UnitCardProps} from './types';

const {seeMap} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export function UnitCard(props: UnitCardProps) {
	const {
		isTelemedicine,
		isNotSelf,
		showDistanceReference,
		nmBairroOrigem,
		phoneNumbers,
		address,
		seeMapDataTagId,
		showDetailsDataTagId,
		callDataTagId,
		bookDataTagId,
		distanceReference,
	} = props;

	const {
		dataTagId,
		handleOpenGoogleMaps,
		getStackDirection,
		getStackAlign,
		addressToDisplay,
		isMobile,
		distanceFilterDescription,
	} = useUnitCard({
		isTelemedicine,
		isNotSelf,
		showDistanceReference,
		nmBairroOrigem,
		phoneNumbers,
		address,
	});

	return (
		<StyledCard $isCursorPointer={false} data-tag-id={dataTagId} elevation={0}>
			<Stack
				gap={isMobile ? 2 : 1}
				flexDirection={getStackDirection()}
				justifyContent={isMobile ? 'space-between' : undefined}
				alignItems={getStackAlign()}
				p={2}
				flex={1}>
				<Stack gap={1} height="100%">
					<UnitCardHeader unitName={props.unitName} query={props.query} />
					<UnitCardAddress
						seeMapDataTagId={seeMapDataTagId}
						address={addressToDisplay}
						onOpenMap={handleOpenGoogleMaps}
						seeMapLabel={seeMap.toLowerCase()}
						showDistanceReference={showDistanceReference}
						distanceFilterDescription={distanceFilterDescription}
						distanceReference={distanceReference}
					/>
				</Stack>
			</Stack>
			<UnitCardActions
				bookDataTagId={bookDataTagId}
				showDetailsDataTagId={showDetailsDataTagId}
				callDataTagId={callDataTagId}
				{...props}
			/>
		</StyledCard>
	);
}
